import React from "react";
// import { Link } from 'react-router-dom'

function First() {

    return (
        <>
            <section id="contact" className="contact-area after-none contact-bg pt-80 pb-80 p-relative fix">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-4 order-1">
                            <div className="contact-info" style={{ display: 'flex', flexDirection: 'column', gap: '2.5rem' }}>
                                <div className="single-cta" style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', paddingBottom: '1rem' }}>
                                    <div className="f-cta-icon" style={{ minWidth: '40px', fontSize: '24px', color: '#bf8c4c' }}>
                                        <i className="far fa-map"></i>
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <h5 style={{ marginBottom: '0.75rem', fontSize: '18px' }}>Dirección</h5>
                                        <p style={{ margin: 0, lineHeight: '1.5', paddingBottom: '0.5rem' }}>Carretera Apan – El Aserradero. CP 43920. Chimalpa, Apan, Hidalgo.</p>
                                    </div>
                                </div>
                                <div className="single-cta" style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', paddingBottom: '1rem' }}>
                                    <div className="f-cta-icon" style={{ minWidth: '40px', fontSize: '24px', color: '#bf8c4c' }}>
                                        <i className="far fa-phone"></i>
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <h5 style={{ marginBottom: '0.75rem', fontSize: '18px' }}>Teléfono</h5>
                                        <p style={{ margin: 0, lineHeight: '1.5', paddingBottom: '0.5rem' }}>55 3455 4183<br />55 6222 3977</p>
                                    </div>
                                </div>
                                <div className="single-cta" style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', paddingBottom: '1rem' }}>
                                    <div className="f-cta-icon" style={{ minWidth: '40px', fontSize: '24px', color: '#bf8c4c' }}>
                                        <i className="far fa-envelope-open"></i>
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <h5 style={{ marginBottom: '0.75rem', fontSize: '18px' }}>Correo</h5>
                                        <p style={{ margin: 0, lineHeight: '1.5', paddingBottom: '0.5rem' }}>recepcion@lafincahz.com<br />direccion@lafincahz.com</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 order-2">
                            <div className="contact-bg02" style={{ margin: "0", padding: "0" }}>
                                <div className="map-container" style={{ width: '100%', height: '380px', borderRadius: '10px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                                    <iframe 
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d60120.15613641884!2d-98.62510052336818!3d19.648245955430642!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d035007d35d031%3A0x64112a97f4861996!2sHotel%20La%20Finca%20Por%20Zotoluca!5e0!3m2!1sen!2sfr!4v1741861423993!5m2!1sen!2sfr" 
                                        width="100%" 
                                        height="100%" 
                                        style={{ border: 0 }} 
                                        allowFullScreen="" 
                                        loading="lazy" 
                                        referrerPolicy="no-referrer-when-downgrade"
                                        title="Hotel La Finca Por Zotoluca Location"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default First;
